if (!customElements.get('about-back-to-top')) {
  class AboutBackToTop extends HTMLElement {
    button = this.querySelector('button');

    connectedCallback() {
      this.button?.addEventListener('click', this.handleClick);
      window.addEventListener('scroll', this.updateVisibility, { passive: true });
      this.updateVisibility();
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleClick);
      window.removeEventListener('scroll', this.updateVisibility);
    }

    handleClick = () => {
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      window.scrollTo({ top: 0, behavior });
    };

    updateVisibility = () => {
      this.classList.toggle('is-visible', window.scrollY > 480);
    };
  }

  customElements.define('about-back-to-top', AboutBackToTop);
}
